import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  order: {}
};

export const ProfileUpdatedSlice = createSlice({
  name: 'Profile-updated',
  initialState,
  reducers: {
    setProfileUpdateStatus: (state, action) => ({
      ...state,
      status: action.payload
    })
  }
});

export const { setProfileUpdateStatus } = ProfileUpdatedSlice.actions;
export default ProfileUpdatedSlice.reducer;
